<template>
  <div class="sheet-panel personality-split">
    <div class="sheet-header">
      <h3>Personality split</h3>
      <button
        class="info-tip"
        title="This section outlines your personality split across 5 bands."
        v-tippy="{ theme: 'navy' }"
      >
        <font-awesome-icon icon="info" />
      </button>
    </div>
    <div class="sheet-content">
      <div class="personality-item ope">
        <div class="personality-score">
          <div class="score">
            <div ref="opeDonut"></div>
            <span>{{ personality.scores.ope }}</span>
          </div>
        </div>
        <div class="personality-description">
          <h3>Openness</h3>
          <p v-if="personality.scores.ope < 30">
            {{ reporting.ope.low }}
          </p>
          <p v-else-if="personality.scores.ope < 70">
            {{ reporting.ope.average }}
          </p>
          <p v-else-if="personality.scores.ope >= 70">
            {{ reporting.ope.high }}
          </p>
        </div>
      </div>

      <div class="personality-item con">
        <div class="personality-score">
          <div class="score">
            <div ref="conDonut"></div>
            <span>{{ personality.scores.con }}</span>
          </div>
        </div>
        <div class="personality-description">
          <h3>Conscientiousness</h3>
          <p v-if="personality.scores.con < 30">
            {{ reporting.con.low }}
          </p>
          <p v-else-if="personality.scores.con < 70">
            {{ reporting.con.average }}
          </p>
          <p v-else-if="personality.scores.con >= 70">
            {{ reporting.con.high }}
          </p>
        </div>
      </div>

      <div class="personality-item ext">
        <div class="personality-score">
          <div class="score">
            <div ref="extDonut"></div>
            <span>{{ personality.scores.ext }}</span>
          </div>
        </div>
        <div class="personality-description">
          <h3>Extraversion</h3>
          <p v-if="personality.scores.ext < 30">
            {{ reporting.ext.low }}
          </p>
          <p v-else-if="personality.scores.ext < 70">
            {{ reporting.ext.average }}
          </p>
          <p v-else-if="personality.scores.ext >= 70">
            {{ reporting.ext.high }}
          </p>
        </div>
      </div>

      <div class="personality-item agr">
        <div class="personality-score">
          <div class="score">
            <div ref="agrDonut"></div>
            <span>{{ personality.scores.agr }}</span>
          </div>
        </div>
        <div class="personality-description">
          <h3>Agreeableness</h3>
          <p v-if="personality.scores.agr < 30">
            {{ reporting.agr.low }}
          </p>
          <p v-else-if="personality.scores.agr < 70">
            {{ reporting.agr.average }}
          </p>
          <p v-else-if="personality.scores.agr >= 70">
            {{ reporting.agr.high }}
          </p>
        </div>
      </div>

      <div class="personality-item neu">
        <div class="personality-score">
          <div class="score">
            <div ref="neuDonut"></div>
            <span>{{ personality.scores.neu }}</span>
          </div>
        </div>
        <div class="personality-description">
          <h3>Neuroticism</h3>
          <p v-if="personality.scores.neu < 30">
            {{ reporting.neu.low }}
          </p>
          <p v-else-if="personality.scores.neu < 70">
            {{ reporting.neu.average }}
          </p>
          <p v-else-if="personality.scores.neu >= 70">
            {{ reporting.neu.high }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import donutty from "donutty";
import { personas, reporting } from "@/assets/static.js";
export default {
  props: {
    personality: Object
  },
  data() {
    return {
      personas: personas,
      reporting: reporting
    };
  },
  mounted() {
    // eslint-disable-next-line
    var opeDonut = new Donutty(this.$refs.opeDonut, {
      value: this.personality.ope,
      color: "#6FC1EF",
      bg: "#F9F9F9"
    });
    // eslint-disable-next-line
    var conDonut = new Donutty(this.$refs.conDonut, {
      value: this.personality.con,
      color: "#8C54E9",
      bg: "#F9F9F9"
    });
    // eslint-disable-next-line
    var extDonut = new Donutty(this.$refs.extDonut, {
      value: this.personality.ext,
      color: "#F3CE5D",
      bg: "#F9F9F9"
    });
    // eslint-disable-next-line
    var agrDonut = new Donutty(this.$refs.agrDonut, {
      value: this.personality.agr,
      color: "#76DFA1",
      bg: "#F9F9F9"
    });
    // eslint-disable-next-line
    var neuDonut = new Donutty(this.$refs.neuDonut, {
      value: this.personality.neu,
      color: "#FC78E7",
      bg: "#F9F9F9"
    });

    opeDonut.set("value", this.personality.scores.ope);
    conDonut.set("value", this.personality.scores.con);
    extDonut.set("value", this.personality.scores.ext);
    agrDonut.set("value", this.personality.scores.agr);
    neuDonut.set("value", this.personality.scores.neu);
  },
  methods: {}
};
</script>
